import _defineProperty2 from "E:\\Agents\\Agent-04\\_work\\53\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _slicedToArray from "E:\\Agents\\Agent-04\\_work\\53\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './Filters.css';
import React from 'react';
import { canUseDOM, get } from '../../utils';
import { ReactComponent as BackArrow } from '../../resources/icons/arrow-left-noborder.svg';
import { filtersStylesLtr, filtersStylesRtl } from '../DynamicListingComponent/DynamicListingComponent';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import DropDown from './DropDown';
import Switch from './Switch';
import Checkbox from './Checkbox';
import DateRange from './DateRange';
import TextFilter from './TextFilter';
import { ANNUAL_FEE, totalParams } from './index';
import { tealiumMergeClickData, tealiumClickFunc } from '../../utils/tealium';
import RangeFilter from './RangeFilter';
import { DropdownResults } from './DropdownResults';
import ImageMultiSelect from './ImageMultiSelect';
import SortDropdown from './SortDropdown';
import NumberDropdown from './NumberDropdown';
import { qsToObject } from '../../utils/querystring';
import { useLocation, useHistory } from 'react-router-dom';
import { toggleLeftPanelOverflow } from '../atoms/InteractiveMap/utils/toggleLeftPanelOverflow';
var Filter = function Filter(_ref) {
  var fields = _ref.fields,
    showLabel = _ref.showLabel,
    resultsLabel = _ref.resultsLabel,
    clearAllLabel = _ref.clearAllLabel,
    selectAllLabel = _ref.selectAllLabel,
    facets = _ref.facets,
    params = _ref.params,
    nbHits = _ref.nbHits,
    setListingFilter = _ref.setListingFilter,
    _ref$facetsStats = _ref.facetsStats,
    facetsStats = _ref$facetsStats === void 0 ? {} : _ref$facetsStats,
    resetFilterCallback = _ref.resetFilterCallback,
    day = _ref.day,
    Cancel = _ref.Cancel,
    FiltersCopy = _ref.FiltersCopy,
    lang = _ref.lang,
    isTagPage = _ref.isTagPage,
    days = _ref.days,
    firstQuery = _ref.firstQuery,
    dictionary = _ref.dictionary,
    imageDictionary = _ref.imageDictionary,
    hits = _ref.hits,
    defaultFacets = _ref.defaultFacets,
    currentTypes = _ref.currentTypes,
    analytics = _ref.analytics,
    _ref$fullWidth = _ref.fullWidth,
    fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
    _ref$showClearAll = _ref.showClearAll,
    showClearAll = _ref$showClearAll === void 0 ? true : _ref$showClearAll,
    _ref$apllyFiltersOnCh = _ref.apllyFiltersOnChange,
    apllyFiltersOnChange = _ref$apllyFiltersOnCh === void 0 ? false : _ref$apllyFiltersOnCh,
    resetAllFiltersCallback = _ref.resetAllFiltersCallback,
    _ref$searchIndex = _ref.searchIndex,
    searchIndex = _ref$searchIndex === void 0 ? '' : _ref$searchIndex,
    _ref$withMapModalView = _ref.withMapModalView,
    withMapModalView = _ref$withMapModalView === void 0 ? false : _ref$withMapModalView,
    dateRangeValue = _ref.dateRangeValue,
    getDateRangeValue = _ref.getDateRangeValue,
    _ref$withMapConfig = _ref.withMapConfig,
    withMapConfig = _ref$withMapConfig === void 0 ? false : _ref$withMapConfig,
    _ref$skipFacetsFilter = _ref.skipFacetsFilter,
    skipFacetsFilter = _ref$skipFacetsFilter === void 0 ? false : _ref$skipFacetsFilter;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var filtersArray = get(fields, 'values');
  var filterWrapperRef = /*#__PURE__*/React.createRef();
  var _React$useState = React.useState(''),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    filterSubpanelText = _React$useState2[0],
    setFilterSubpanelText = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    clearAlllFilters = _React$useState4[0],
    setclearAlllFilters = _React$useState4[1];
  var _React$useState5 = React.useState(true),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    firstFilter = _React$useState6[0],
    setFirstFilter = _React$useState6[1];
  var _React$useState7 = React.useState(true),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    startPage = _React$useState8[0],
    setStartPage = _React$useState8[1];
  var _React$useState9 = React.useState(false),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    isSubmenuOpen = _React$useState10[0],
    setSubmenuOpen = _React$useState10[1];
  var _React$useState11 = React.useState(0),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    filtersCount = _React$useState12[0],
    setFiltersCount = _React$useState12[1];
  var _React$useState13 = React.useState({}),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    filtersValue = _React$useState14[0],
    setFiltersValue = _React$useState14[1];
  var _React$useState15 = React.useState(totalParams()),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    totalFilters = _React$useState16[0],
    settotalFilters = _React$useState16[1];
  var location = useLocation();
  var history = useHistory();
  var queryParams = qsToObject(location.search);
  React.useEffect(function () {
    filtersArray && filtersArray.map(function (el) {
      var preselectedTags = el.preselectedTags && el.preselectedTags.values.map(function (tag) {
        return get(tag, 'title.value') || get(tag, 'name');
      });
      var fieldNameItem = get(el, 'fieldNameItem.item.fieldName.value');
      var queries = queryParams["".concat(fieldNameItem)];
      if (!queries) {
        setFiltersValue(function (prev) {
          return _objectSpread(_objectSpread({}, prev), {}, _defineProperty2({}, el.name, {
            value: el.preselectedTags && el.preselectedTags.values.length !== 0 ? preselectedTags.join(',') : null,
            facet: fieldNameItem
          }));
        });
      } else {
        setFiltersValue(function (prev) {
          return _objectSpread(_objectSpread({}, prev), {}, _defineProperty2({}, el.name, {
            value: queries,
            facet: fieldNameItem
          }));
        });
      }
    });
  }, []);
  React.useEffect(function () {
    var count = 0;
    var _loop = function _loop(key) {
      var isFullFalseObj = function isFullFalseObj() {
        var isFullFalseObj = true;
        if (filtersValue[key].value !== null) {
          Object.values(filtersValue[key].value).forEach(function (el) {
            if (el) {
              isFullFalseObj = false;
            }
          });
        }
        return isFullFalseObj;
      };
      if (typeof filtersValue[key].value === 'string' ? filtersValue[key].value !== null : !isFullFalseObj()) {
        count = count + 1;
      }
    };
    for (var key in filtersValue) {
      _loop(key);
    }
    setFiltersCount(count);
  }, [filtersValue]);
  var filterSubPanelToggle = function filterSubPanelToggle(toggle) {
    var closePanel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (filterWrapperRef.current) {
      if (toggle) {
        filterWrapperRef.current.classList.remove('filter__wrapper--submenu-open');
        setStartPage(true);
        setFirstFilter(true);
        setSubmenuOpen(false);

        // close common filter dropdown
        if (closePanel) {
          filterWrapperRef.current.classList.remove('filter__wrapper--open');
          document.body.classList.remove('filter__wrapper--open');
          toggleMapButton(false);
          setStartPage(true);
          setFirstFilter(true);
        }
      } else {
        filterWrapperRef.current.classList.add('filter__wrapper--submenu-open');
        setStartPage(false);
        setFirstFilter(false);
        setSubmenuOpen(true);
      }
      if (withMapModalView) {
        toggleLeftPanelOverflow(filterWrapperRef);
      }
    }
  };
  var clearKeyPressHandler = function clearKeyPressHandler(e) {
    if (e.which === 13 || e.which === 32) {
      e.preventDefault();
      clearAllCallback();
    }
  };
  var setFilter = function setFilter() {
    var firstFilter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    setclearAlllFilters(false);
    setFirstFilter(firstFilter);
    setSubmenuOpen(false);
    setListingFilter();
    // setTimeout(() => {
    // getFilterValue()
    // settotalFilters(totalParams());
    // }, 10);
  };
  var getFilterValue = function getFilterValue(fieldName, facet, filterValue) {
    if (filterValue === null || filterValue === '' || filterValue.length === 0 || Object.keys(filterValue).length === 0) {
      setFiltersValue(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, _defineProperty2({}, fieldName, {
          value: null,
          facet: facet
        }));
      });
    } else {
      setFiltersValue(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, _defineProperty2({}, fieldName, {
          value: filterValue,
          facet: facet
        }));
      });
    }
  };
  var clearAllCallback = function clearAllCallback() {
    tealiumClickFunc(tealiumMergeClickData(analytics.filterClearAllDateAnalytics, analytics.params));
    setclearAlllFilters(true);
    filterSubPanelToggle(true, false);
    setTimeout(function () {
      filtersArray && filtersArray.map(function (el) {
        var facetName = get(el, 'fieldNameItem.item.fieldName.value');
        setFiltersValue(function (prev) {
          return _objectSpread(_objectSpread({}, prev), {}, _defineProperty2({}, el.name, {
            value: null,
            facet: facetName
          }));
        });
      });
    }, 10);
    if (withMapConfig && getDateRangeValue) {
      getDateRangeValue({
        date: '',
        dateInit: undefined,
        formattedDate: ''
      });
    }
  };
  var controlBackBtn = function controlBackBtn(isOpen) {
    setStartPage(isOpen);
  };
  var theme = get(sitecoreContext, 'themesOfPage');
  var themePrimary = get(theme, 'primary');
  var themePrimary__active = get(theme, 'primary_active');
  var submitAll = function submitAll() {
    var splitter = ';,;';
    var url = new URL(window.location.href);
    var newQueryArr = [];
    filtersArray.forEach(function (el) {
      filtersValue[el.name] = _objectSpread(_objectSpread({}, filtersValue[el.name]), {}, {
        fieldType: el.fieldTypeItem.item.fieldType.value
      });
    });
    var _loop2 = function _loop2(key) {
      if (typeof filtersValue[key].value === 'object' && filtersValue[key].value !== null && (filtersValue[key].fieldType === 'Dropdown' || filtersValue[key].fieldType === 'Dropdown Multi Select' || filtersValue[key].fieldType === 'Image Multi Select')) {
        if (filtersValue[key].value.length) {
          filtersValue[key].value.forEach(function (key) {
            newQueryArr.push(key);
          });
        } else {
          Object.keys(filtersValue[key].value).forEach(function (el) {
            if (filtersValue[key].value[el]) {
              var index = newQueryArr.indexOf(filtersValue[key].value[el]);
              if (index === -1) {
                newQueryArr.push(el);
              }
            }
          });
        }
        if (newQueryArr.length) {
          url.searchParams.set(filtersValue[key].facet, newQueryArr.join(splitter));
          history.push("".concat(url.search).concat(url.hash));
          setListingFilter();
          newQueryArr = [];
        }
      } else {
        if (filtersValue[key].value !== null) {
          url.searchParams.set(filtersValue[key].facet, "".concat(filtersValue[key].value));
          history.push("".concat(url.search).concat(url.hash));
          setListingFilter();
        }
      }
    };
    for (var key in filtersValue) {
      _loop2(key);
    }
    filterSubPanelToggle(true);
    tealiumClickFunc(tealiumMergeClickData(analytics.filterShowResultsAnalytics, analytics.params));
  };
  var toggleMapButton = function toggleMapButton() {
    var hide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (canUseDOM) {
      var button = document.querySelector('#interactive-map-toggle');
      if (button) {
        button.style.zIndex = hide ? '1' : '2';
      }
    }
  };
  var columnsClass = withMapModalView ? 'col-md-12' : filtersArray.length === 2 ? 'col-md-6' : 'col-md-4';
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    themePrimary: themePrimary,
    themePrimary__active: themePrimary__active,
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter__wrapper ".concat(withMapModalView ? 'map-view' : ''),
    ref: filterWrapperRef
  }, /*#__PURE__*/React.createElement("div", {
    className: "row mob-filter-toggle"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(withMapModalView ? 'col-12 imfilters-padding' : 'col-12 col-md-4')
  }, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      document.body.classList.add('filter__wrapper--open');
      filterWrapperRef.current.classList.add('filter__wrapper--open');
      toggleMapButton(true);
      if (withMapModalView) {
        toggleLeftPanelOverflow(filterWrapperRef);
      }
      tealiumClickFunc(tealiumMergeClickData(analytics.filterClickAnalytics, analytics.params));
    },
    className: "btn btn-secondary js-filters-trigger filter__toggle"
  }, FiltersCopy, " ", filtersCount > 0 && "(".concat(filtersCount, ")"))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }), !withMapModalView && /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filters-bottom-hr"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "filter"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter__scroll"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter__header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/React.createElement("span", {
    onClick: function onClick(e) {
      filterSubPanelToggle(true, false);
      tealiumClickFunc(tealiumMergeClickData(analytics.filterClearAllDateAnalytics, analytics.params), 'Cancel');
      if (withMapModalView) {
        toggleLeftPanelOverflow(filterWrapperRef);
      }
      e.stopPropagation();
    },
    className: "body-medium filter__header-back-link js-btn-close-panel"
  }, /*#__PURE__*/React.createElement(BackArrow, {
    className: "brand-icon"
  })), /*#__PURE__*/React.createElement("span", {
    className: "body-medium filter__header-links js-filters-close ".concat(startPage ? 'cancel' : 'back'),
    onClick: function onClick() {
      tealiumClickFunc(tealiumMergeClickData(analytics.filterClearAllDateAnalytics, analytics.params), 'Back');
      if (startPage) {
        setStartPage(true);
        toggleMapButton(false);
        filterWrapperRef.current.classList.remove('filter__wrapper--open');
        document.body.classList.remove('filter__wrapper--open');
      } else {
        setStartPage(true);
        setFirstFilter(true);
      }
      if (withMapModalView) {
        toggleLeftPanelOverflow(filterWrapperRef);
      }
    }
  }, /*#__PURE__*/React.createElement(BackArrow, {
    className: "brand-icon"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter__header-text body-medium"
  }, /*#__PURE__*/React.createElement("span", null, FiltersCopy, " "), /*#__PURE__*/React.createElement("span", {
    className: "js-opened-filter-label submenu__text"
  }, filterSubpanelText))), /*#__PURE__*/React.createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/React.createElement("span", {
    className: "body-medium filter__header-links",
    onClick: function onClick() {
      clearAllCallback();
      tealiumClickFunc(tealiumMergeClickData(analytics.filterClearAllDateAnalytics, analytics.params), 'Clear all');
    }
  }, clearAllLabel)))), /*#__PURE__*/React.createElement("div", {
    className: "filter__row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "\n                ".concat(withMapModalView ? 'col-md col-xl-12' : !fullWidth ? 'col-md col-xl-9 offset-xl-1' : 'col-md', "\n                 ")
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, filtersArray && filtersArray.map(function (filter, index) {
    var filterName = get(filter, 'name');
    var fieldTypeItem = get(filter, 'fieldTypeItem.item.fieldType.value');
    var fieldNameItem = get(filter, 'fieldNameItem.item.fieldName.value');
    var fieldNamesItem = get(filter, 'fieldNameItems.items.0.fieldName.value');
    var item = !fieldNameItem ? get(filter, 'fieldNameItem.item', {}) : [];
    var fieldNameItemArray = !fieldNameItem ? Object.keys(item).map(function (name) {
      return get(item, "".concat(name, ".value"));
    }) : [];
    var itemfacets;
    var defaultItemFacets;
    if (facets && defaultFacets) {
      itemfacets = facets[fieldNameItem] || facets[fieldNamesItem] || facets[fieldNameItem + 'RangeIndex'];
      defaultItemFacets = defaultFacets[fieldNameItem] || defaultFacets[fieldNamesItem] || defaultFacets[fieldNameItem + 'RangeIndex'];
    }
    if (fieldTypeItem === 'Dropdown') {
      return /*#__PURE__*/React.createElement(DropDown, {
        columnsClass: columnsClass
        // key={`${index}-${filterName}`}
        ,

        key: "".concat(withMapModalView ? "map-view-".concat(index, "-").concat(filterName) : "".concat(index, "-").concat(filterName)),
        fields: filter,
        showLabel: showLabel,
        resultsLabel: resultsLabel,
        clearAllLabel: clearAllLabel,
        facetsName: fieldNameItem,
        facets: itemfacets,
        defaultFacets: defaultItemFacets,
        firstFilter: firstFilter,
        nbHits: nbHits,
        firstQuery: firstQuery,
        indexDropDown: "".concat(withMapModalView ? "map-view-".concat(index, "-").concat(filterName) : "".concat(index, "-").concat(filterName)),
        setFilter: setFilter,
        wrapperToggle: filterSubPanelToggle,
        setSubpanelLabel: setFilterSubpanelText,
        clearAlllFilters: clearAlllFilters,
        analytics: analytics,
        hideShowButton: apllyFiltersOnChange,
        keepOpenOnChange: true,
        setStartPage: controlBackBtn,
        getFilterValue: getFilterValue,
        resetAllFiltersCallback: resetAllFiltersCallback,
        withMapModalView: withMapModalView
      });
    } else if (fieldTypeItem === 'Dropdown Multi Select') {
      return /*#__PURE__*/React.createElement(DropDown, {
        columnsClass: columnsClass
        // key={`${index}-${filterName}`}
        ,

        key: "".concat(withMapModalView ? "map-view-".concat(index, "-").concat(filterName) : "".concat(index, "-").concat(filterName)),
        fields: filter,
        showLabel: showLabel,
        resultsLabel: resultsLabel,
        clearAllLabel: clearAllLabel,
        selectAllLabel: selectAllLabel,
        facets: itemfacets,
        facetsName: fieldNameItem,
        defaultFacets: defaultItemFacets,
        firstFilter: firstFilter,
        nbHits: nbHits,
        firstQuery: firstQuery,
        indexDropDown: "".concat(withMapModalView ? "map-view-".concat(index, "-").concat(filterName) : "".concat(index, "-").concat(filterName)),
        setFilter: setFilter,
        wrapperToggle: filterSubPanelToggle,
        setSubpanelLabel: setFilterSubpanelText,
        clearAlllFilters: clearAlllFilters,
        analytics: analytics,
        hideShowButton: apllyFiltersOnChange,
        keepOpenOnChange: true,
        setStartPage: controlBackBtn,
        getFilterValue: getFilterValue,
        resetAllFiltersCallback: resetAllFiltersCallback,
        withMapModalView: withMapModalView
      });
    } else if (fieldTypeItem == 'Dropdown result') {
      return /*#__PURE__*/React.createElement(DropdownResults, {
        columnsClass: columnsClass,
        filteredOptions: hits ? hits : [],
        label: fieldNameItem
      });
    } else if (fieldTypeItem === 'Text') {
      return /*#__PURE__*/React.createElement(TextFilter, {
        key: "".concat(index, "-").concat(filterName),
        columnsClass: columnsClass,
        params: params,
        fields: filter,
        showLabel: showLabel,
        resultsLabel: resultsLabel,
        clearAllLabel: clearAllLabel,
        facets: itemfacets,
        facetsName: fieldNameItem,
        defaultFacets: defaultItemFacets,
        firstFilter: firstFilter,
        nbHits: nbHits,
        firstQuery: firstQuery,
        indexDropDown: index,
        setFilter: setFilter,
        wrapperToggle: filterSubPanelToggle,
        setSubpanelLabel: setFilterSubpanelText,
        clearAlllFilters: clearAlllFilters,
        rtl: rtl,
        analytics: analytics,
        fullWidth: filtersArray.filter(function (f) {
          return get(f, 'fieldNameItems.items', []).some(function (i) {
            return get(i, 'fieldName.value', '').includes('venueMeetingRooms');
          });
        }),
        getFilterValue: getFilterValue
      });
    } else if (fieldTypeItem === 'Range') {
      return /*#__PURE__*/React.createElement(RangeFilter, {
        columnsClass: columnsClass,
        key: "".concat(index, "-").concat(filterName),
        fields: filter,
        showLabel: showLabel,
        resultsLabel: resultsLabel,
        queryString: fieldNameItem === 'maxDelegates' ? fieldNameItem : ANNUAL_FEE,
        clearAllLabel: clearAllLabel,
        facets: itemfacets,
        facetsStats: facetsStats && facetsStats[ANNUAL_FEE],
        facetsName: fieldNameItem,
        defaultFacets: defaultItemFacets,
        firstFilter: firstFilter,
        nbHits: nbHits,
        firstQuery: firstQuery,
        indexDropDown: index,
        setFilter: setFilter,
        wrapperToggle: filterSubPanelToggle,
        setSubpanelLabel: setFilterSubpanelText,
        clearAlllFilters: clearAlllFilters,
        hits: hits || [],
        analytics: analytics,
        setStartPage: controlBackBtn,
        getFilterValue: getFilterValue
      });
    } else if (fieldTypeItem === 'Range Multi Select') {
      return /*#__PURE__*/React.createElement(RangeFilter, {
        columnsClass: columnsClass,
        key: "".concat(index, "-").concat(filterName),
        fields: filter,
        queryString: fieldNameItem === 'maxDelegates' ? fieldNameItem : ANNUAL_FEE,
        showLabel: showLabel,
        resultsLabel: resultsLabel,
        clearAllLabel: clearAllLabel,
        facets: itemfacets,
        facetsStats: facetsStats && facetsStats[ANNUAL_FEE],
        facetsName: fieldNameItem,
        defaultFacets: defaultItemFacets,
        firstFilter: firstFilter,
        nbHits: nbHits,
        firstQuery: firstQuery,
        indexDropDown: index,
        setFilter: setFilter,
        wrapperToggle: filterSubPanelToggle,
        setSubpanelLabel: setFilterSubpanelText,
        clearAlllFilters: clearAlllFilters,
        hits: hits || [],
        isMultiSelect: true,
        analytics: analytics,
        getFilterValue: getFilterValue
      });
    } else if (fieldTypeItem === 'Switch') {
      return /*#__PURE__*/React.createElement(Checkbox, {
        key: "".concat(index, "-").concat(filterName),
        columnsClass: columnsClass,
        setFilter: setFilter,
        facetsName: fieldNameItem,
        fields: filter,
        wrapperToggle: filterSubPanelToggle,
        clearAlllFilters: clearAlllFilters,
        analytics: analytics,
        getFilterValue: getFilterValue,
        withMapModalView: withMapModalView
      });
    } else if (fieldTypeItem === 'Toggle Multi Select') {
      return /*#__PURE__*/React.createElement(Switch, {
        key: "".concat(index, "-").concat(filterName),
        facets: itemfacets,
        defaultFacets: defaultItemFacets,
        facetsName: fieldNameItem,
        selectAllLabel: selectAllLabel,
        firstQuery: firstQuery,
        fields: filter,
        day: day,
        days: days,
        wrapperToggle: filterSubPanelToggle,
        setFilter: setFilter,
        clearAlllFilters: clearAlllFilters,
        isTagPage: isTagPage,
        dictionary: dictionary,
        firstFilter: firstFilter,
        analytics: analytics,
        getFilterValue: getFilterValue,
        rtl: rtl,
        resetAllFiltersCallback: resetAllFiltersCallback,
        withMapModalView: withMapModalView,
        skipFacetsFilter: skipFacetsFilter
      });
    } else if (fieldTypeItem === 'Toggle Single Select') {
      return /*#__PURE__*/React.createElement(Switch, {
        key: "".concat(index, "-").concat(filterName),
        facets: itemfacets,
        defaultFacets: defaultItemFacets,
        selectAllLabel: selectAllLabel,
        facetsName: fieldNameItem,
        firstQuery: firstQuery,
        fields: filter,
        day: day,
        days: days,
        wrapperToggle: filterSubPanelToggle,
        setFilter: setFilter,
        clearAlllFilters: clearAlllFilters,
        isTagPage: isTagPage,
        dictionary: dictionary,
        firstFilter: firstFilter,
        analytics: analytics,
        getFilterValue: getFilterValue,
        rtl: rtl,
        resetAllFiltersCallback: resetAllFiltersCallback,
        withMapModalView: withMapModalView,
        skipFacetsFilter: skipFacetsFilter
      });
    } else if (fieldTypeItem === 'Date Range' || fieldTypeItem === 'Deals Date Range') {
      return /*#__PURE__*/React.createElement(DateRange, {
        key: "".concat(index, "-").concat(filterName),
        columnsClass: columnsClass,
        clearAlllFilters: clearAlllFilters,
        fields: filter,
        clearAllCallback: resetFilterCallback,
        showLabel: showLabel,
        resultsLabel: resultsLabel,
        facetsName: fieldNameItemArray,
        clearAllLabel: clearAllLabel,
        setFilter: setFilter,
        wrapperToggle: filterSubPanelToggle,
        setSubpanelLabel: setFilterSubpanelText,
        lang: lang,
        analytics: analytics,
        setStartPage: controlBackBtn,
        submenuHelper: isSubmenuOpen,
        getFilterValue: getFilterValue,
        withMapModalView: withMapModalView,
        withMapConfig: withMapConfig,
        dateRangeValue: dateRangeValue,
        getDateRangeValue: getDateRangeValue
      });
    } else if (fieldTypeItem === 'Date') {
      return /*#__PURE__*/React.createElement(DateRange, {
        key: "".concat(index, "-").concat(filterName),
        columnsClass: columnsClass,
        clearAlllFilters: clearAlllFilters,
        fields: filter,
        clearAllCallback: resetFilterCallback,
        showLabel: showLabel,
        resultsLabel: resultsLabel,
        facetsName: fieldNameItemArray,
        clearAllLabel: clearAllLabel,
        setFilter: setFilter,
        wrapperToggle: filterSubPanelToggle,
        setSubpanelLabel: setFilterSubpanelText,
        lang: lang,
        analytics: analytics,
        setStartPage: controlBackBtn,
        submenuHelper: isSubmenuOpen,
        getFilterValue: getFilterValue,
        withMapModalView: withMapModalView,
        withMapConfig: withMapConfig,
        dateRangeValue: dateRangeValue,
        getDateRangeValue: getDateRangeValue
      });
    } else if (fieldTypeItem === 'Sort') {
      return /*#__PURE__*/React.createElement(SortDropdown, {
        key: "".concat(index, "-").concat(filterName),
        columnsClass: columnsClass,
        fields: filter,
        showLabel: showLabel,
        resultsLabel: resultsLabel,
        clearAllLabel: clearAllLabel,
        selectAllLabel: selectAllLabel,
        facets: get(filter, 'fieldNameItems.items'),
        facetsName: get(filter, 'fieldNameItems.items', []).map(function (f) {
          return get(f, 'fieldName.value', '');
        }),
        dictionary: dictionary,
        defaultFacets: get(filter, 'fieldNameItems.items'),
        firstFilter: firstFilter,
        nbHits: nbHits,
        firstQuery: firstQuery,
        indexDropDown: index,
        setFilter: setFilter,
        wrapperToggle: filterSubPanelToggle,
        setSubpanelLabel: setFilterSubpanelText,
        clearAlllFilters: clearAlllFilters,
        analytics: analytics,
        hideShowButton: apllyFiltersOnChange,
        getFilterValue: getFilterValue,
        resetAllFiltersCallback: resetAllFiltersCallback,
        searchIndex: searchIndex
      });
    } else if (fieldTypeItem === 'Number') {
      return /*#__PURE__*/React.createElement(NumberDropdown, {
        key: "".concat(index, "-").concat(filterName),
        columnsClass: columnsClass,
        fields: filter,
        showLabel: showLabel,
        resultsLabel: resultsLabel,
        clearAllLabel: clearAllLabel,
        selectAllLabel: selectAllLabel,
        facetsName: fieldNameItem,
        dictionary: dictionary,
        firstFilter: firstFilter,
        nbHits: nbHits,
        firstQuery: firstQuery,
        indexDropDown: index,
        setFilter: setFilter,
        wrapperToggle: filterSubPanelToggle,
        setSubpanelLabel: setFilterSubpanelText,
        clearAlllFilters: clearAlllFilters,
        analytics: analytics,
        hideShowButton: apllyFiltersOnChange,
        getFilterValue: getFilterValue,
        resetAllFiltersCallback: resetAllFiltersCallback
      });
    } else if (fieldTypeItem === 'Image Multi Select') {
      return /*#__PURE__*/React.createElement(ImageMultiSelect, {
        filter: filter,
        hits: hits,
        params: params,
        facets: itemfacets,
        dictionary: dictionary,
        analytics: analytics,
        imageDictionary: imageDictionary,
        facetsName: fieldNamesItem,
        setFilter: setFilter,
        clearAlllFilters: clearAlllFilters,
        getFilterValue: getFilterValue
      });
    } else {
      return /*#__PURE__*/React.createElement("div", {
        key: index
      });
    }
  }))), filtersArray.length > 1 && showClearAll && /*#__PURE__*/React.createElement("div", {
    className: "col-md-auto col-lg-2 d-flex justify-content-end align-items-end filter__col-clear"
  }, /*#__PURE__*/React.createElement("button", {
    onKeyPress: clearKeyPressHandler,
    onClick: clearAllCallback,
    className: "body-medium link-clear filter-panel__row-clear btn--reset"
  }, clearAllLabel)))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md ".concat(currentTypes && currentTypes[0] == 'type:Video Details Page' ? 'col-xl-11' : 'col-xl-11', "  offset-xl-1")
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filters-bottom-hr"
  })))))), /*#__PURE__*/React.createElement("div", {
    className: "filter__btn-row"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: submitAll,
    className: "btn btn-primary js-filters-close"
  }, showLabel, " ", resultsLabel)))));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    themePrimary = _ref2.themePrimary,
    themePrimary__active = _ref2.themePrimary__active;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " ").concat(stylesInteractiveMapModal, "  ").concat(rtl ? filtersStylesRtl : filtersStylesLtr, " ").concat(rtl ? rtlStyles : '', "  ").concat(rtl ? rtlStylesInteractiveMapModal : '', " ")
  }, children);
};
export default Filter;
var commonStyles = "caod502";
var stylesInteractiveMapModal = "s1bg7ezf";
var rtlStylesInteractiveMapModal = "r37wpvb";
var rtlStyles = "r1lklj7f";